import {ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal} from "@angular/core";

@Component({
    selector: "woa-card-brand",
    templateUrl: "./card-brand.component.html",
    styleUrl: "./card-brand.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardBrandComponent {
    public readonly brand: InputSignal<string> = input<string>();
    public readonly cardNumber: InputSignal<string> = input<string>();

    public readonly displayBrand: Signal<string> = computed(() => {
        // If card number is provided, auto-detect the brand, otherwise use supplied brand
        return !this.cardNumber() ? this.brand()?.toUpperCase()
            : this.cardNumber().startsWith("5") ? "MASTERCARD"
                : this.cardNumber().startsWith("4") ? "VISA"
                    : this.cardNumber().startsWith("34") || this.cardNumber().startsWith("37") ? "AMEX"
                        : this.brand();
    });
}
